import React from 'react';

const AgeRangeFilter = ({ selectedAgeRange, onAgeRangeChange }) => {
    // Using the actual age range constants from backend with emojis
    const ageRanges = [
        { id: '1-2', emoji: '👶', label: 'Ages 1-2' },
        { id: '3-5', emoji: '🧒', label: 'Ages 3-5' },
        { id: '6-8', emoji: '👧', label: 'Ages 6-8' },
        { id: '9-11', emoji: '👦', label: 'Ages 9-11' },
        { id: '12-14', emoji: '🧑', label: 'Ages 12-14' },
        { id: '15-17', emoji: '👨‍🎓', label: 'Teens' },
        { id: '18+', emoji: '👩‍💼', label: 'Adults' },
        { id: 'ALL', emoji: '👨‍👩‍👧‍👦', label: 'All Ages' }
    ];

    return (
        <div>
            <h3 className="font-medium text-accent-800 mb-3 flex items-center">
                🎂 Age Range
            </h3>

            <div className="grid grid-cols-2 gap-2">
                {ageRanges.map((ageRange) => (
                    <button
                        key={ageRange.id}
                        onClick={() => onAgeRangeChange(ageRange.id)}
                        className={`p-2 rounded-lg text-center transition-all duration-200 ${selectedAgeRange === ageRange.id
                            ? 'border-2 border-blue-600 bg-blue-200 shadow-inner transform scale-95'
                            : 'border-2 border-accent-200 hover:border-accent-300 bg-white hover:bg-accent-50 shadow-sm'
                            }`}
                    >
                        <div className="text-lg mb-1">{ageRange.emoji}</div>
                        <div className={`text-xs ${selectedAgeRange === ageRange.id
                            ? 'font-bold text-blue-800'
                            : 'font-medium text-accent-600'
                            }`}>
                            {ageRange.label}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AgeRangeFilter; 